import React from 'react';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Button, withStyles, Typography, FormControlLabel } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import i18next from 'i18next';
import moment from 'moment';
import { faCalendarAlt, faChevronDown } from '@fortawesome/pro-light-svg-icons';
import StyledCheckbox from '../Checkbox/StyledCheckbox';

const styles = theme => ({
    drp: {
        width: 'max-content'
    },
    drpButton: {
        width: '100%',
        height: '100%',
        border: '1px solid #E6EDF5',
        padding: '10px',
        margin: '5px 0px',
        marginTop: -15,
        justifyContent: 'flex-start !important'
    },
    calendarIcon: {
        marginRight: '3px',
        color: '#357ebd',
    },
    containerStylesContainer: {
        marginLeft: 'auto',

    },
    chevronIcon: {
        marginLeft: '7px',
        color: '#357ebd',
    },
    containerStyles: {
        width: '100%',
        // height: '44px'
    },
    labelWrapper: {
        height: 'fit-content',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        marginBottom: '20px'
    },
    label: {
        color: '#878787',
        flex: 1,
        fontSize: 12,
    },
    dateContainer: {
        width: '100%'
    },
    foreverCheck: {
        marginTop: -10,
        marginLeft: -9,
    },
    maxLength: {
        color: '#A9A9A9',
        fontSize: '10px',
        textAlign: 'left'
    },
    error: {
        borderColor: 'red'
    },
    errorDate: {
        margin: 0,
        textAlign: 'right',
        height: 0
    },
    checkLabel: {
        fontSize: 12
    }
});

class ReactDateRangePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentLang: i18next.language
        };
    }

    componentDidUpdate = () => {
        if (i18next.language !== this.state.currentLang) {
            this.setState({
                currentLang: i18next.language,
            });
        };
    }

    render() {
        const { t, sameDate = false, classes, headerStyle, singleDayToggle, date, customContainerStyle,
            customClass, label, description, disabled = false, onForever = false,
            forever = false, foreverLabel = 'Forever', isEmpty = false, format = "MM-DD-YYYY", timePicker = false,
            onApply, onHide, autoApply = true, ...other } = this.props;

        let customClassAUX = typeof customClass !== undefined ? customClass : '';
        let containerStylesAUX = typeof customContainerStyle !== undefined ? customContainerStyle : '';

        let locale = {
            format: format,
            search: 'Filtrer',
            daysOfWeek: moment.weekdaysShort(),
            monthNames: moment.months(),
        };
        let button = (
            <Button disabled={disabled} className={clsx(classes.drpButton, customClassAUX, (sameDate || isEmpty) && classes.error)}>
                <div className="pull-left">
                    <FontAwesomeIcon className={classes.calendarIcon} icon={faCalendarAlt} />
                    <span>
                        {forever ? foreverLabel : date}
                    </span>
                </div>
                <div className={clsx(classes.containerStylesContainer, "pull-right")}>
                    <FontAwesomeIcon className={classes.chevronIcon} icon={faChevronDown} />
                </div>
            </Button>
        )

        return (
            <React.Fragment>
                <div className={classes.dateContainer}>
                    {label ?
                        <div className={clsx(classes.labelWrapper, headerStyle)}>
                            <Typography className={clsx(classes.label)}>{label}</Typography>
                        </div>
                        : ''}
                    {singleDayToggle}
                    {description ?
                        <div className={clsx(classes.labelWrapper)}>
                            <Typography className={clsx(classes.label)} >{description.slice(0, 55)}</Typography>
                        </div>
                        : ''}
                    {disabled ? button :
                        <DateRangePicker
                            key={'_' + Math.random().toString(36).substr(2, 9)}
                            className={classes.drp}
                            initialSettings={{
                                autoApply: autoApply,
                                applyClass: 'singleDatePicker',
                                locale: locale,
                                alwaysShowCalendars: false,
                                containerClass: clsx(classes.containerStyles, containerStylesAUX),
                                timePicker: timePicker,
                                ...other,
                            }}
                            onApply={onApply}
                            onHide={onHide}
                        >
                            {button}
                        </DateRangePicker>
                    }
                    {sameDate && <p className={classes.errorDate}><small className={classes.maxLength}>*Minimun range allowed is 1 day</small></p>}
                    {onForever && <FormControlLabel
                        className={classes.foreverCheck}
                        control={
                            <StyledCheckbox
                                checked={forever}
                                onClick={onForever}
                                small={true}
                            />}
                        label={<span className={classes.checkLabel}>{foreverLabel}</span>}
                    />}
                </div>
            </React.Fragment>
        );
    }
}

export default withTranslation('common')(withStyles(styles)(ReactDateRangePicker));